import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  CardFooter,
  Row,
  Col,
  Container,
  Form,
  Input,
  FormGroup,
  Label,
  Button,
  Modal
} from "reactstrap";
import BootstrapTable from 'react-bootstrap-table-next'
import DateTime from 'react-datetime'
import "react-datetime/css/react-datetime.css"
import Iframe from 'react-iframe';
import paginationFactory from 'react-bootstrap-table2-paginator'

import ReactSelect from 'components/Form/Select/Select'
import useForm from "lib/useForm"
import Loading from 'lib/loading'
import rotas from 'services/rotas'
import rest from 'lib/rest'
import {homepage} from '../../../../package.json';


const EstatisticaProjecao = () => {

  const inicialResumo = {
    balcao:   0,
    delivery: 0,
    total:    0,
  }

  const [form, onChange, setForm, onChangeSelect, onChangeDate] = useForm([])
  const [loading, setLoading]                                   = useState(false)
  const [loadingTabela, setLoadingTabela]                       = useState(false)
  const [lojas, setLojas]                                       = useState([])
  const [dadosDetalhado, setDadosDetalhado]                     = useState([])
  const [resumo, setResumo]                                     = useState(inicialResumo)
  const [divResumo, setdivResumo]                               = useState('d-none')
  const [pathPDF, setPathPDF]                                   = useState('')
  const [modalPrint, setModalPrint]                             = useState(false)

  const colunas = [
    {
      dataField: 'vendedor',
      text: 'Vendedor',
      headerStyle: { cursor: 'text' }
    },
    {
      dataField: 'balcao',
      text: 'Balcão',
      headerStyle: { cursor: 'text' },
      // sort: true,
      formatter: (cellContent, row) => {return (parseFloat(cellContent).toLocaleString('pt-br', { style: 'currency', currency: 'BRL',minimumFractionDigits: 1, maximumFractionDigits: 2 }))}
    },
    {
      dataField: 'delivery',
      text: 'Delivery',
      headerStyle: { cursor: 'text' },
      // sort: true,
      formatter: (cellContent, row) => {return (parseFloat(cellContent).toLocaleString('pt-br', { style: 'currency', currency: 'BRL',minimumFractionDigits: 1, maximumFractionDigits: 2 }))}
    }
  ]

  const listaLojas = () => {
    let lista = []
    const url = rotas.lojas
    try{
      const retorno = rest.get(url)
      retorno.then(ret => {
        if (ret.success && ret.success == 'S' && ret.lista != ''){
          for (let i = 0; i < ret.lista.length; i++) {
            lista[i] = {"id":ret.lista[i].filial_id, "title":ret.lista[i].fantasia}
          }
          setLojas(lista)
        }
      })
    }catch(err){
      console.log(err)
    }
  }

  const imprimirPDF = () => {
    if (dadosDetalhado.length > 0) {
      
      let dados = {
        rede:     sessionStorage.getItem('rede'),
        usuario:  sessionStorage.getItem('usuario'),
        dataI:    form['inicio'],
        dataF:    form['final'],
        lista:    dadosDetalhado,
        total:    resumo
      }
  
      try{
        const url     = rotas.estatisticaDelivery+"pdf/"
        const retorno = rest.post(url, dados);
  
        retorno.then(ret => {
          if (ret.success && ret.success == 'S' && ret.path != '' && ret.path != null) {
            let caminho = url.split('/');
            let caminhoPDF = '';
  
            for(let x = 0 ; x < caminho.length -1 ; x++){
              if(caminhoPDF === ''){
                caminhoPDF = caminho[x]; 
              }else{
                caminhoPDF = caminhoPDF + '/' + caminho[x];
              }
            }
            setPathPDF( homepage + '/' + caminhoPDF + ret.path);
            setModalPrint(true);
  
          } else {
            console.log(ret);
            // Swal.fire('Erro', 'Erro na geração da impresão', 'error');
          }
        })
      }catch(err){
        console.log(err)
      }
    }
  }

  const pesquisaSubmit = (e) => {
    e.preventDefault()

    setdivResumo('d-none')
    setLoadingTabela(true)

    const url     = rotas.estatisticaDelivery
    const retorno = rest.post(url, form)

    try {
      retorno.then(ret => {
        console.log(ret);
        if (ret.success && ret.success == 'S'){
          setDadosDetalhado(ret.lista)
          setResumo(ret.total)
          setdivResumo('')
        }else{
          setDadosDetalhado([])
          setResumo(inicialResumo)
        }
        setLoadingTabela(false)
      })
    } catch (error) {
      console.log(error);
      setDadosDetalhado([])
      setResumo(inicialResumo)
      setLoadingTabela(false)
    }
  }

  useEffect(() => {
    listaLojas()
  }, [])

  if (loading) {
    return ( <Loading tipo='paginas' /> )

  } else {
    return (
      <div className="content" key="contPrincipal">
        <Container>
          <Row>
            <Col md="12" className="p-0">
              <Card>
                <CardHeader>
                  <CardTitle>ESTATÍSTICA DE DELIVERY</CardTitle>
                </CardHeader>

                <CardBody>
                  <div className="border p-3">
                    <Form onSubmit={pesquisaSubmit}>
                      <Container>
                        <Row>

                          <Col md='8'>
                            <FormGroup className="mb-0">
                              <ReactSelect
                                isMulti
                                name          = "lojas"
                                placeholder   = "Selecione a Loja"
                                options       = {lojas}
                                defaultValue  = {form.filialSelect}
                                onChange      = {onChangeSelect('filialSelect')}
                                onClick       = {form.filialSelect ? form.filial = form.filialSelect.id : ''}
                              ></ReactSelect>
                            </FormGroup>
                          </Col>

                          <Col md='2'>
                            <FormGroup className="mb-0">
                              <DateTime
                                id            = "dataInicial"
                                name          = "dataInicial"
                                inputProps    = {{ placeholder: "Período Inicial" }}
                                closeOnSelect = {true}
                                dateFormat    = "DD/MM/YYYY"
                                timeFormat    = {false}
                                value         = {form.inicio}
                                onChange      = {onChangeDate('inicio')}
                              >
                              </DateTime>
                            </FormGroup>
                          </Col>
                          
                          <Col md='2'>
                            <FormGroup className="mb-3">
                              <DateTime
                                id            = "dataFinal"
                                name          = "dataFinal"
                                inputProps    = {{ placeholder: "Período Final" }}
                                closeOnSelect = {true}
                                timeFormat    = {false}
                                dateFormat    = "DD/MM/YYYY"
                                value         = {form.final}
                                onChange      = {onChangeDate('final')}
                              >
                              </DateTime>
                            </FormGroup>
                          </Col>
                        </Row>

                        <Row style={{ display: "flex", justifyContent: "right", }}>
                          <Col md='2' style={{ display: "flex", justifyContent: "right", }}>
                            <FormGroup className="mb-0">
                              <Button
                                color   = "warning"
                                onClick = {imprimirPDF}
                              >
                                IMPRIMIR
                                <i className="nc-icon nc-single-copy-04 pl-2" style={{ fontSize: '18px' }} />
                              </Button>
                            </FormGroup>
                          </Col>
                          
                          <Col md="2" style={{ display: "flex", justifyContent: "right", }}>
                            <FormGroup className="mb-0">
                              <Button 
                                color = "success"
                                type  = 'submit'
                              >
                                Gerar
                                <i className="nc-icon nc-zoom-split pl-2" style={{ fontSize: '18px' }} />
                              </Button>
                            </FormGroup>
                          </Col>

                        </Row>
                      </Container>
                    </Form>

                    <Container className="mt-3">
                      {
                        loadingTabela ?  <Loading tipo='componente' /> 
                        :
                          <BootstrapTable
                            striped
                            keyField          = 'curva_classificacao'
                            data              = {dadosDetalhado}
                            columns           = {colunas}
                            noDataIndication  = "Nenhum registro encontrado"
                            rowStyle          = {{ cursor: "pointer" }}
                            pagination        = {paginationFactory({
                                                  sizePerPage: 20,
                                                  hideSizePerPage: true,
                                                  hidePageListOnlyOnePage: true,
                                                  showTotal: false,
                                                })}
                          />
                      }

                      <Row className={divResumo}>
                        <Col md="4">
                          <div className="card-2 pl-3 ml-0">
                            <Col md="12">
                              <span className="tag-card">
                                  <span className="form-check-sign bg-success" />Total Balcão
                              </span>
                            </Col>
                            <Row>
                              <Col>
                              <FormGroup className="text-center">
                                <Input
                                  disabled
                                  name      = "balcao"
                                  type      = "text"
                                  className = "text-center font-weight-bold text-success"
                                  value     = {parseFloat(resumo['balcao']).toLocaleString('pt-br', { style: 'currency', currency: 'BRL',minimumFractionDigits: 1, maximumFractionDigits: 2 })}
                                />
                              </FormGroup>
                              </Col>
                            </Row>
                            
                          </div>
                        </Col>

                        <Col md="4">
                          <div className="card-2 pl-3 ml-0">
                            <Col md="12">
                              <span className="tag-card">
                                  <span className="form-check-sign bg-warning" />Total delivery
                              </span>
                            </Col>
                            <Row>
                              <Col>
                              <FormGroup className="text-center">
                                <Input
                                  disabled
                                  name      = "delivery"
                                  type      = "text"
                                  className = "text-center font-weight-bold text-success"
                                  value     = {parseFloat(resumo['delivery']).toLocaleString('pt-br', { style: 'currency', currency: 'BRL',minimumFractionDigits: 1, maximumFractionDigits: 2 })}
                                />
                              </FormGroup>
                              </Col>
                            </Row>
                            
                          </div>
                        </Col>

                        <Col md="4">
                          <div className="card-2 pl-3 ml-0">
                            <Col md="12">
                              <span className="tag-card">
                                <span className="form-check-sign bg-danger" />valor total vendido
                              </span>
                            </Col>
                            <Row>
                              <Col>
                              <FormGroup className="text-center">
                                <Input
                                  disabled
                                  name      = "totalVendido"
                                  type      = "text"
                                  className = "text-center font-weight-bold text-success"
                                  value     = {parseFloat(resumo['total']).toLocaleString('pt-br', { style: 'currency', currency: 'BRL',minimumFractionDigits: 1, maximumFractionDigits: 2 })}
                                />
                              </FormGroup>
                              </Col>
                            </Row>
                            
                          </div>
                        </Col>
                      </Row>

                    </Container>

                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <Modal
          key     = 'modrelat'
          size    = 'xl'
          height  = "700px"
          isOpen  = {modalPrint}
        >
          <Iframe
            allowFullScreen
            id        = "myId"
            name      = "myId"
            className = "myClassname"
            width     = "100%"
            height    = "580px"
            display   = "initial"
            position  = "relative"
            url       = {pathPDF}
            >
          </Iframe>
          <Row>
            <Col className="text-center p-3">
              <Button
                type      = "button"
                className = "mb-0 mt-0"
                color     = "success"
                size      = "md"
                onClick   = {()=>{window.open(pathPDF)}}
              >Baixar
              </Button>
              <Button
                type      = "button"
                className = "mb-0 mt-0"
                color     = "default"
                size      = "md"
                onClick   = {()=>{setModalPrint(false)}}
              >Fechar
              </Button>
            </Col>
          </Row>
        </Modal>
      </div>
    )
  }
}

export default EstatisticaProjecao
